import { Formik, Form } from 'formik';
import { useNavigate, Link } from "react-router-dom";
import axios from 'axios';
import { successAlert, errorAlert } from '../utils/toastifyAlerts'
import { ToastContainer } from 'react-toastify'
import logo from '../assets/img/logo.png'

export default function RegistrationPage() {

  const navigate = useNavigate()
  const backendUrl = process.env.REACT_APP_BACKEND_USERS_URL
  const handleSubmit = async (values) => {
    try {
      await axios.post(backendUrl, {
        userName: values.userName,
        name: values.name,
        lastName: values.lastName,
        email: values.email,
        password: values.password,
        password_confirmation: values.passwordAgain,
      }).then(function (response) {
        successAlert(response.data.msg)
        setTimeout(() => {
          navigate('/login');
        }, 6000);
      })
    } catch (error) {
      let msgs = error.response.data.errors
      msgs.forEach((element) => {
        errorAlert(`Registration failed: \n ${element.msg}`)
      });
    }
  }

  return (
    <div className="App register">
      <div className="registration-title">
        <h1>
          <img className='img-logo' src={logo} alt="simple resume logo" />
          registration
        </h1>
      </div>
      <Formik
        initialValues={{ userName: '', name: '', lastName: '', email: '', password: '', passwordAgain: '' }}
        validate={values => {
          const errors = {};
          if (!values.email) {
            errors.email = 'Required';
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
          ) {
          } else if (!values.name) {
            errors.name = 'Required';
          } else if (!values.lastName) {
            errors.lastName = 'Required';
            errors.email = 'Invalid email address';
          } else if (values.password !== values.passwordAgain) {
            errors.passwordAgain = 'Passwords should match';
          }
          return errors;
        }}
        onSubmit={async (values) => {
          await handleSubmit(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form className='form-register' onSubmit={handleSubmit}>
            <input
              className='input-form'
              type="username"
              name="userName"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.userName}
              placeholder='user name'
              data-test="userName"
            />
            {errors.userName && touched.userName && errors.userName}
            <input
              className='input-form'
              type="email"
              name="email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
              placeholder='email'
            />
            {errors.email && touched.email && errors.email}
            <input
              className='input-form'
              type="name"
              name="name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.name}
              placeholder='name'
              data-test="name"
            />
            {errors.name && touched.name && errors.name}
            <input
              className='input-form'
              type="lastName"
              name="lastName"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.lastName}
              placeholder='last name'
              data-test="lastName"
            />
            {errors.lastName && touched.lastName && errors.lastName}
            <input
              className='input-form'
              type="password"
              name="password"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.password}
              placeholder='password'
              data-test="password"
            />
            {errors.password && touched.password && errors.password}
            <input
              className='input-form'
              type="password"
              name="passwordAgain"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.passwordAgain}
              placeholder='password again please'
              data-test="passwordAgain"
            />
            {errors.passwordAgain && touched.passwordAgain && errors.passwordAgain}
            <button className='btnSCV btnSCV-a btnSCV-long' type="submit" disabled={isSubmitting}>
              submit
            </button>
            {/* <label>
              <Field type="checkbox" name="info" value="info" />
              <p className='miniText'>recieve information related with simple.CV</p>
            </label> */}
            {/* <label>
              <Field type="checkbox" name="info" value="policy" />
              <p className='miniText'>By signing up, you agree to Photo’s Terms of Service and
                Privacy Policy.</p>
            </label> */}

            <Link className="btnSCV btnSCV-c btnSCV-long" to="/">back</Link>
          </Form>
        )}
      </Formik>
      <ToastContainer />

    </div>
  );
}
